import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 接口地址
import * as shopinfo from '@/api/mall/shopinfo';
import { getPage, getPageByShop, addObj, putObj, delObj } from '@/api/mall/pagedevise';
import { getObj2 } from '@/api/mall/thememobile';
// 商城页面装修必须引入 ----- 开始 -----
// 商城装修为单独模块，可提供按需购买方式
// 全局搜【todo divpageShop】可查看所有关联到的文件
import Vue from 'vue';
import '@/views/mall/pagedevise/component-library/plugins/index';
// 图片轮播组件 swiper组件 npm i vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper /* { default global options } */);
import '@/views/mall/pagedevise/component-library/directive'; //自定义事件引入
import '@/views/mall/pagedevise/component-library/libs/utils'; //引入property 方法
import "../assets/iconfont/iconfont.css"; // 字体
import VueClipboard from 'vue-clipboard2'; // 剪贴板组件
Vue.use(VueClipboard);
// 商城页面装修必须引入 ----- 结束 -----

import draggable from "vuedraggable";
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
// 组件
import swiperComponent from "../components/swiper.vue";
import imageComponent from "../components/image.vue";
import settingSlot from "../component-setting/settingSlot";
import bgColorSelect from "../pages/page-components/bgColorSelect";

// 组件设置
import pageSetting from "../component-setting/pageSetting.vue";
import swiperSetting from "../component-setting/swiperSetting.vue";
import imageSetting from "../component-setting/imageSetting.vue";
import navButtonComponent from "../components/navButton.vue";
import navButtonSetting from "../component-setting/navButtonSetting.vue";
import noticeComponent from "../components/notice.vue";
import noticeSetting from "../component-setting/noticeSetting.vue";
import titleTextComponent from "../components/titleText.vue";
import titleTextSetting from "../component-setting/titleTextSetting.vue";
import goodsComponent from "../components/goods.vue";
import goodsSetting from "../component-setting/goodsSetting.vue";
import shopInfoComponent from "../components/shopInfo.vue";
import shopInfoSetting from "../component-setting/shopInfoSetting.vue";
import goodsRowComponent from "../components/goodsRow.vue";
import goodsRowSetting from "../component-setting/goodsRowSetting.vue";
import searchComponent from "../components/search.vue";
import searchSetting from "../component-setting/searchSetting.vue";

// 营销组件
import couponComponent from "../components/coupon.vue";
import couponSetting from "../component-setting/couponSetting.vue";
import bargainComponent from "../components/bargain.vue";
import bargainSetting from "../component-setting/bargainSetting.vue";
import grouponComponent from "../components/groupon.vue";
import grouponSetting from "../component-setting/grouponSetting.vue";
import seckillComponent from "../components/seckill.vue";
import seckillSetting from "../component-setting/seckillSetting.vue";
import imageMultiSetting from "@/views/mall/pagedevise/component-library-shop/component-setting/imageMultiSetting";
import goodsNewSetting from "@/views/mall/pagedevise/component-library-shop/component-setting/goodsNewSetting";
import imageMultiComponent from "@/views/mall/pagedevise/component-library-shop/components/imageMulti";
import goodsNewComponent from "@/views/mall/pagedevise/component-library-shop/components/goodsNew";
export default {
  components: {
    draggable: draggable,
    imageComponent: imageComponent,
    swiperComponent: swiperComponent,
    navButtonComponent: navButtonComponent,
    noticeComponent: noticeComponent,
    titleTextComponent: titleTextComponent,
    goodsComponent: goodsComponent,
    goodsRowComponent: goodsRowComponent,
    searchComponent: searchComponent,
    shopInfoComponent: shopInfoComponent,
    pageSetting: pageSetting,
    imageSetting: imageSetting,
    swiperSetting: swiperSetting,
    navButtonSetting: navButtonSetting,
    noticeSetting: noticeSetting,
    titleTextSetting: titleTextSetting,
    goodsSetting: goodsSetting,
    goodsRowSetting: goodsRowSetting,
    searchSetting: searchSetting,
    shopInfoSetting: shopInfoSetting,
    couponComponent: couponComponent,
    bargainComponent: bargainComponent,
    grouponComponent: grouponComponent,
    seckillComponent: seckillComponent,
    imageMultiComponent: imageMultiComponent,
    goodsNewComponent: goodsNewComponent,
    couponSetting: couponSetting,
    bargainSetting: bargainSetting,
    grouponSetting: grouponSetting,
    seckillSetting: seckillSetting,
    imageMultiSetting: imageMultiSetting,
    goodsNewSetting: goodsNewSetting,
    bgColorSelect: bgColorSelect,
    settingSlot: settingSlot
  },
  props: {},
  created: function created() {
    var _this = this;
    if (this.$route.params.shopId) {
      this.id = this.$route.params.shopId;
      this.initPageData.pageName = this.$route.params.shopName;
      this.initPageData.shopId = this.$route.params.shopId;
    }
    getObj2().then(function (response) {
      _this.thememobile = response.data.data;
      _this.$nextTick(function () {
        if (!_this.initPageData.pageComponent.backgroundColor) _this.initPageData.pageComponent.backgroundColor = 'bg-' + _this.thememobile.backgroundColor;
      });
    });
    // this.getShopList();
  },
  data: function data() {
    return {
      noPic: require("../assets/images/icon/img_pic@2x.png"),
      thememobile: {
        backgroundColor: ''
      },
      shopList: [],
      id: null,
      // 注意：这个ID为shopId
      shopInfo: {
        imgUrl: '',
        address: '',
        phone: '',
        name: '',
        collectCount: ''
      },
      initPageData: {
        shopId: '',
        pageName: '店铺首页',
        pageType: '2',
        pageComponent: {
          textColor: '',
          tabTextColor: '',
          backgroundColor: '',
          componentsList: []
        }
      },
      enabled: true,
      activeNames: ['imageModule', 'functionModule'],
      showPageSet: false,
      //页面设置
      showSetBlock: false,
      settingPosit: {
        top: 0,
        left: 0,
        timeStamp: 0
      },
      addCompBtns: {
        baseModule: [{
          name: '搜索',
          img: require("../assets/images/icon/ic_search.png"),
          eventPayload: {
            name: 'searchComponent',
            payLoad: {}
          }
        }, {
          name: '店铺信息',
          img: require("../assets/images/icon/ic_shop.png"),
          eventPayload: {
            name: 'shopInfoComponent',
            payLoad: {}
          }
        }, {
          name: '单图',
          img: require("../assets/images/icon/ic_pic.png"),
          eventPayload: {
            name: 'imageComponent',
            payLoad: {
              singleImg: true
            }
          }
        }, {
          name: '多图',
          img: require("../assets/images/icon/ic_image_multi.png"),
          eventPayload: {
            name: 'imageMultiComponent',
            payLoad: {}
          }
        }, {
          name: '热选爆款',
          img: require("../assets/images/icon/ic_goods_recommend.png"),
          eventPayload: {
            name: 'goodsNewComponent',
            payLoad: {}
          }
        }, {
          name: '轮播图',
          img: require("../assets/images/icon/ic_swiper.png"),
          eventPayload: {
            name: 'swiperComponent',
            payLoad: {}
          }
        }, {
          name: '导航按钮',
          img: require("../assets/images/icon/ic_nav.png"),
          eventPayload: {
            name: 'navButtonComponent',
            payLoad: {}
          }
        }, {
          name: '通知公告',
          img: require("../assets/images/icon/ic_notice.png"),
          eventPayload: {
            name: 'noticeComponent',
            payLoad: {}
          }
        }, {
          name: '标题文字',
          img: require("../assets/images/icon/ic_tittle.png"),
          eventPayload: {
            name: 'titleTextComponent',
            payLoad: {}
          }
        }, {
          name: '商品推荐',
          img: require("../assets/images/icon/ic_goods.png"),
          eventPayload: {
            name: 'goodsComponent',
            payLoad: {}
          }
        }, {
          name: '商品甄选',
          img: require("../assets/images/icon/ic_recommend.png"),
          eventPayload: {
            name: 'goodsRowComponent',
            payLoad: {}
          }
        }],
        functionModule: [{
          name: '优惠券',
          img: require("../assets/images/icon/ic_coupon.png"),
          eventPayload: {
            name: 'couponComponent',
            payLoad: {}
          }
        }, {
          name: '砍价',
          img: require("../assets/images/icon/ic_bargain.png"),
          eventPayload: {
            name: 'bargainComponent',
            payLoad: {}
          }
        }, {
          name: '拼团',
          img: require("../assets/images/icon/ic_groupon.png"),
          eventPayload: {
            name: 'grouponComponent',
            payLoad: {}
          }
        }, {
          name: '秒杀',
          img: require("../assets/images/icon/ic_seckill.png"),
          eventPayload: {
            name: 'seckillComponent',
            payLoad: {}
          }
        }]
      },
      // clickComIndex : null,        //当前点击的组件下标
      currentComType: "",
      //当前点击的组件类型；
      showData: {},
      comConfig: {},
      showSetBtn: false,
      initPageHeight: 680 + 65 + 90,
      //初始化显示高度为680(加上top栏高度  页面的顶部图片高度)
      setBlockTop: 0,
      //设置框的相对top值
      setRowTop: 0,
      //设置框的箭头的相对top值
      showSetCompet: "",
      //显示设置的组件块
      pageDiyId: "",
      pageName: "",
      //页面名称
      pageSort: [] //页面分类
    };
  },

  computed: _objectSpread(_objectSpread({}, mapState({
    pageSetData: function pageSetData(state) {
      return state.divpageShop.pageSetData;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpageShop.clickComIndex;
    },
    showModal: function showModal(state) {
      return state.divpageShop.showModal;
    },
    pageId: function pageId(state) {
      return state.divpageShop.pageId;
    },
    //页面ID（店铺装修暂时忽略不用）
    shopId: function shopId(state) {
      return state.divpageShop.shopId;
    } //店铺ID
  })), {}, {
    componentsList: {
      get: function get() {
        return this.$store.state.divpageShop.componentsList;
      },
      set: function set(newVal) {
        this.$store.commit('updateData', {
          componentsList: newVal
        });
      }
    },
    pageBg: function pageBg() {
      if (this.initPageData.pageComponent.backgroundColor) {
        if (this.initPageData.pageComponent.backgroundColor.indexOf('bg-') != -1) {
          return this.initPageData.pageComponent.backgroundColor;
        } else {
          return this.initPageData.pageComponent.backgroundColor;
        }
      } else {
        return '';
      }
    }
  }),
  mounted: function mounted() {
    var that = this;
    // 滑动监听
    // that.$refs.componentsDiv.addEventListener("scroll", that.componentDivScroll);
    //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.initPage();
  },
  destroyed: function destroyed() {
    window.localStorage.removeItem('divPageShopId');
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    confirmPageSet: function confirmPageSet() {
      this.showSetBlock = false;
      this.showPageSet = true;
      setInterval(function () {
        var body = {
          "courseId": 13563,
          "sectionId": 54937,
          "projectId": 1235,
          "videoDuration": 6269,
          "watchAt": '999',
          "topicId": "",
          "activityId": "8a8080be81f0976d01823838985b0047"
        };
        //随机数
        var watchVal = Math.ceil(Math.random() * 3) + 3;
        body.watchAt = watchVal + body.watchAt;
        console.log(body);
      }, 1000);
    },
    onPageSet: function onPageSet() {
      this.initPageData.pageComponent.backgroundColor = this.initPageData.pageComponent.backgroundColor;
      this.showSetBlock = false;
      this.showPageSet = true;
    },
    getShopInfo: function getShopInfo() {
      var _this2 = this;
      shopinfo.getObj(this.initPageData.shopId).then(function (response) {
        var curShop = response.data.data;
        _this2.initPageData.shopId = curShop.id;
        _this2.initPageData.pageName = curShop.name;
        _this2.shopInfo = curShop;
        _this2.id = _this2.initPageData.shopId;
        _this2.getPageData();
      });
    },
    shopChange: function shopChange(value) {
      if (value) {
        var curShop = null;
        this.shopList.map(function (item) {
          if (item.id == value) {
            curShop = item;
            return;
          }
        });
        if (curShop) {
          this.initPageData.shopId = curShop.id;
          this.initPageData.pageName = curShop.name;
          this.shopInfo = curShop;
        }
      }
      this.id = this.initPageData.shopId;
      this.getPageData();
    },
    getShopList: function getShopList() {
      var _this3 = this;
      //获取所有店铺
      shopinfo.getPage({}).then(function (response) {
        _this3.shopList = response.data.data.records;
      }).catch(function () {});
    },
    initPage: function initPage() {
      var _this4 = this;
      var that = this;
      if (this.$route.params.shopId) {
        that.updateData({
          shopId: this.$route.params.shopId
        });
        window.localStorage.setItem('divPageShopId', this.shopId);
      } else {
        var divPageShopId = window.localStorage.getItem('divPageShopId');
        if (divPageShopId) {
          that.updateData({
            shopId: divPageShopId
          });
        }
      }
      this.id = this.shopId;
      this.initPageData.shopId = this.shopId;
      // that.pageDiyId= that.$route.query.diyId || '';//预留
      // that.pageName = that.$route.query.pageName || '';
      // that.pageSort = that.$route.query.sort ? that.$route.query.sort.split(',') : [];
      this.getShopInfo(); //页面数据
      // 监听页面刷新,保存当前ID
      window.addEventListener('beforeunload', function (e) {
        window.localStorage.setItem('divPageShopId', _this4.shopId);
      });
    },
    getPageData: function getPageData() {
      var _this5 = this;
      if (this.id && this.id != 'null') {
        getPageByShop({
          shopId: this.initPageData.shopId,
          clientType: -1,
          pageType: 2
        }).then(function (response) {
          if (response.data.data.records) {
            if (response.data.data.records.length > 0) {
              var res = response.data.data.records[0];
              if (!res.pageComponent.backgroundColor) {
                res.pageComponent.backgroundColor = '';
              }
              if (!res.pageComponent.textColor) {
                res.pageComponent.textColor = '';
              }
              _this5.initPageData = res;
            } else {
              // this.initPageData = {
              //   shopId: this.id,
              //   pageName: '店铺首页',
              //   pageType: '2',
              //   pageComponent: {
              //     componentsList: []
              //   }
              // }
            }
            // this.initPageData = response.data.data
            _this5.getComponentsDataById();
          } else {
            _this5.initShop();
          }
        }).catch(function (e) {});
      } else {
        this.initShop();
      }
    },
    initShop: function initShop() {
      this.initPageData = {
        shopId: this.id,
        pageName: '店铺首页',
        pageType: '2',
        pageComponent: {
          backgroundColor: 'bg-' + this.thememobile.backgroundColor,
          componentsList: []
        }
      };
      this.updateData({
        showModal: false,
        clickComIndex: null,
        componentsList: this.initPageData.pageComponent.componentsList
      });
    },
    handleSave: function handleSave() {
      var _this6 = this;
      this.initPageData.pageType = '2';
      // this.initPageData.shopId = '';
      // this.initPageData.pageName = 'd首页';
      this.initPageData.pageComponent.componentsList = this.componentsList;
      if (this.initPageData.id) {
        putObj(this.initPageData).then(function (response) {
          _this6.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
        }).catch(function () {});
      } else {
        if (!this.initPageData.shopId) {
          this.$message({
            showClose: true,
            message: '请先选择一个店铺！',
            type: 'info'
          });
          return;
        }
        addObj(this.initPageData).then(function (response) {
          _this6.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          });
          // this.$router.$avueRouter.closeTag();
          // this.$router.back();
          if (response.data.data.id) {
            _this6.initPageData.id = response.data.data.id;
            _this6.updateData({
              pageId: response.data.data.id
            });
            window.localStorage.setItem('divPageShopId', _this6.pageId);
            _this6.initPage();
          }
        }).catch(function () {});
      }
    },
    // 获取回显数据
    getComponentsDataById: function getComponentsDataById(id) {
      var that = this;
      that.componentsList = [];
      if (this.initPageData.pageComponent && this.initPageData.pageComponent.componentsList && this.initPageData.pageComponent.componentsList.length > 0) {
        that.componentsList = this.initPageData.pageComponent.componentsList;
        // 数据筛选 避免无效数据
        that.componentsList = that.componentsList.filter(function (item) {
          return item.componentName;
        });
        that.updateData({
          componentsList: that.componentsList
        });
      }
    },
    // 添加组件
    addComponents: function addComponents(cName) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.initPageData.shopId) {
        this.$message({
          showClose: true,
          message: '请先选择一个店铺！',
          type: 'info'
        });
        return;
      }
      var that = this;
      //计算动态的id值
      var componentsLen = this.componentsList ? this.componentsList.length : 0;
      var dynamicID = componentsLen ? that.componentsList.reduce(function (item1, item2) {
        return item1.id > item2.id ? item1 : item2;
      }).id + 1 : 1;
      that.componentsList.push({
        componentName: cName,
        id: dynamicID,
        data: {},
        config: config
      });
      that.updateData({
        componentsList: that.componentsList
      });
      // 显示最新添加的模块
      that.$nextTick(function () {
        var newComponentEle = that.$refs['drag-item-' + dynamicID][0];
        // newComponentEle.scrollIntoView({
        //   // behavior: 'smooth',
        //   block   : 'end'
        // })
        setTimeout(function () {
          var event = new MouseEvent("click");
          newComponentEle.dispatchEvent(event);
        }, 100);
      });
    },
    changeShopBg: function changeShopBg(value) {
      this.initPageData.pageComponent.backgroundColor = value;
    },
    // 展示设置框
    showSetting: function showSetting(index, cid, cName) {
      this.showPageSet = false;
      var that = this;
      if (index != that.clickComIndex || !that.showSetBlock) {
        that.showSetBlock = false;
        that.$nextTick(function () {
          that.showSetBlock = true;
        });
      }
      that.showSetCompet = that.$refs['drag-item-' + cid][0];
      var elPositionInfo = that.showSetCompet.getBoundingClientRect();
      that.updateData({
        clickComIndex: index
      });
      that.$set(that.settingPosit, 'top', elPositionInfo.top <= 160 ? 160 : elPositionInfo.top - 80);
      that.$set(that.settingPosit, 'left', elPositionInfo.width + 20);
      that.$set(that.settingPosit, 'timeStamp', new Date().getTime());
      this.currentComType = cName.split('Component')[0];
      this.showData = that.componentsList[that.clickComIndex]['data'];
      this.comConfig = that.componentsList[this.clickComIndex]['config'];
      this.showSetBtn = true;
    },
    // 取消设置
    settingCancel: function settingCancel() {
      var that = this;
      that.showData = {};
      that.updateData({
        clickComIndex: null
      });
      that.showSetBlock = false;
    },
    // 确认设置
    settingConfirm: function settingConfirm(data) {
      var that = this;
      that.$set(that.componentsList[that.clickComIndex], 'data', data);
      that.updateData({
        clickComIndex: null,
        componentsList: that.componentsList
      });
      that.showSetBlock = false;
    },
    // 删除组件
    deleteComponent: function deleteComponent() {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.componentsList.splice(that.clickComIndex, 1);
        that.updateData({
          showModal: false,
          clickComIndex: null,
          componentsList: that.componentsList
        });
        that.showSetBlock = false;
        that.showSetBtn = false;
      });
    },
    //排序
    componentSort: function componentSort(type) {
      var that = this;
      if (type == 'up') {
        if (that.clickComIndex == 0) return false;
        that.dataInterchange(that.componentsList, that.clickComIndex - 1, that.clickComIndex);
        that.updateData({
          clickComIndex: that.clickComIndex - 1
        });
      } else {
        if (that.clickComIndex == that.componentsList.length - 1) return false;
        that.dataInterchange(that.componentsList, that.clickComIndex + 1, that.clickComIndex);
        that.updateData({
          clickComIndex: that.clickComIndex + 1
        });
      }
      that.showSetBlock = false;
      // 设置跟随；
      that.$nextTick(function () {
        var activeComponentData = that.componentsList[that.clickComIndex];
        var activeComponenttEle = that.$refs['drag-item-' + activeComponentData.id][0];
        // activeComponenttEle.scrollIntoView({block: 'center'});
        that.showSetting(that.clickComIndex, activeComponentData.id, activeComponentData.componentName);
      });
    },
    // 提交页面
    submitData: function submitData() {
      var that = this;
      return new Promise(function (resolve, reject) {
        if (that.componentsList && that.componentsList.length) {
          resolve(JSON.stringify(that.componentsList));
        } else {
          resolve();
          // reject({code: 100, msg: "未添加组件"})
        }
      });
    },
    // 拖动的事件等等=======================================================>
    datadragStart: function datadragStart(e) {
      var that = this;
      that.updateData({
        clickComIndex: null
      });
      that.showSetBlock = false;
    },
    datadragUpdate: function datadragUpdate(e) {
      e.preventDefault();
    },
    datadragEnd: function datadragEnd(e) {
      // console.log(e, "拖动结束");
    },
    datadragMove: function datadragMove(e, originalEve) {
      return e.draggedContext.element.text !== 'Gold（不可拖动元素）';
    },
    // div中内容滚动检测 （右侧设置的动态显示）
    componentDivScroll: function componentDivScroll(e) {
      // let that = this;
      // if(!that.showSetCompet) return false;
      //
      // let elPositionInfo = that.showSetCompet.getBoundingClientRect();
      // that.$set(that.settingPosit, 'top', elPositionInfo.top<=160 ? 160 : elPositionInfo.top )
      // let contentHeight = e.target.scrollHeight;
      // let viewHeight    = e.target.clientHeight;
      // let scrollTop     = e.target.scrollTop;
      //
      // let eleHeight     = elPositionInfo.height;
      // let eleOffsetTop  = that.showSetCompet.offsetTop;
      //
      // let AMEND_TOP = 30 + 65;    // 顶部消失的修正值
      // let AMEND_BOTTOM = -20;      // 底部消失的修正值
      // let topCritical    = scrollTop > (eleHeight + eleOffsetTop - AMEND_TOP);          // 顶部达到临界
      // let bottomCritical = eleOffsetTop > (scrollTop + viewHeight - AMEND_BOTTOM);      // 底部达到临界
      // (topCritical || bottomCritical) && that.settingCancel();
    },
    modifySetPosition: function modifySetPosition(settingTop) {
      var that = this;
      that.$nextTick(function () {
        setTimeout(function () {
          var settingEle = that.$refs.settingBlock;
          if (!settingEle) return false;
          var setHeight = settingEle.getBoundingClientRect().height;
          if (settingTop + setHeight > that.initPageHeight) {
            that.setBlockTop = that.initPageHeight - setHeight;
            that.setRowTop = setHeight - (that.initPageHeight - settingTop);
          } else {
            that.setBlockTop = settingTop < 0 ? 0 : settingTop;
            that.setRowTop = 0;
          }
        }, 20);
      });
    }
  }),
  // 离开
  // beforeRouteLeave(to, from, next){
  //   let that = this;
  //   that.componentsList = [];
  //   that.updateData({componentsList: that.componentsList});
  //   that.$store.commit('updateData', {showModal: false});
  //   next()
  //     that.$confirm('离开后数据将清空', '提示', {
  //         confirmButtonText: '确定',
  //         cancelButtonText : '取消',
  //         type : 'warning'
  //     }).then(()=>{
  //         that.$parent.shwoBackup();
  //         // 清除遮罩
  //         that.$store.commit('updateData', {showModal: false});
  //         next()
  //     })
  // },
  watch: {
    showModal: function showModal(newVal) {
      var _this7 = this;
      this.$nextTick(function () {
        _this7.showSetBtn = _this7.showSetBlock = newVal;
      });
    },
    settingPosit: {
      handler: function handler(newVal) {
        this.modifySetPosition(newVal.top);
      },
      deep: true
    }
  }
};